import "./content-switcher/content-switcher";
import "./list-locations/list-locations";
import "./slider-medias/slider-medias";